module.exports = __webpack_public_path__ + "static/img/tx_1.a14c06e5.png";